<template>
  <div>
    <table class="table_PTableSimple" aria-describedby="pTableSimple">
      <thead>
        <tr class="tr_PTableSimple">
          <th v-for="(th, indexTh) in fields" :key="indexTh + 'field'" class="th_PTableSimple">
            {{ th.label }}
          </th>
        </tr>
      </thead>
      <tbody>
        <template v-for="(tr, indexTr) in items">
          <tr :key="indexTr + 'tr'" class="tr_PTableSimple">
            <td v-for="(td, indexTd) in fields" :key="indexTd + 'td'" class="td_PTableSimple">
              <slot :name="td.key" :item="tr" :showExtend="() => showExtendItem(indexTr)">
                {{ tr[td.key] }}
              </slot>
            </td>
          </tr>
          <tr :key="indexTr + 'trExtend'" v-show="isExtendShowItem(indexTr)">
            <td :colspan="fields.length">
              <slot
                name="extend"
                :item="tr"
                :index="indexTr"
                :showExtend="() => showExtendItem(indexTr)"
              >
              </slot>
            </td>
          </tr>
        </template>
        <template v-if="!items || items.length === 0">
          <tr class="tr_PTableSimple">
            <td :colspan="fields.length" class="td_PTableSimple">
              <div class="text-center">{{ $t("label.sinDatos") }}</div>
            </td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>
<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export class PTableSimple extends Vue {
  @Prop({ required: true }) items!: any[];
  @Prop({ required: true }) fields!: any[];
  showItems: number[] = [];
  showExtendItem(index: number): void {
    const numIndex = this.showItems.findIndex((showItem) => showItem === index);
    if (numIndex > -1) {
      this.showItems.splice(numIndex, 1);
    } else {
      this.showItems.push(index);
    }
  }
  isExtendShowItem(index: number): boolean {
    return this.showItems.findIndex((showItem) => showItem === index) > -1;
  }
}
export default PTableSimple;
</script>
<style lang="scss" scoped>
.table_PTableSimple {
  width: 100%;

  .tr_PTableSimple {
    border-bottom: solid 1px rgb(183, 183, 183, 0.4);
  }
  .td_PTableSimple,
  .th_PTableSimple {
    padding: 0.5em;
  }
  .th_PTableSimple {
    color: #808080;
    text-transform: uppercase;
  }
}
</style>
